import apiClient from "../apiClient";

// get Tool Category list
export const getSideMenuOptionService = async () => {
  try {
    const response = await apiClient.get(`/api/site-bar-special-data`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};
